export const getIssueUsers = (attempt, issue, users) => {
  const currentUserId =
    issue.issueResult?.submittedByUserId || attempt.assignedUserId;

  let relatedUserId = null;
  if (attempt.multiTechnicianAttempt) {
    const relatedIssue = attempt.multiTechnicianAttempt.issues.find(
      (x) => x.id === issue.id
    );

    if (relatedIssue) {
      relatedUserId =
        relatedIssue.issueResult?.submittedByUserId ||
        attempt.multiTechnicianAttempt.userId;
    }
  }

  const ids = [relatedUserId, currentUserId].filter(Boolean);

  return users.filter((x) => ids.findIndex((y) => x.id === y) !== -1);
};
